import { Injectable } from '@angular/core';
import { ProfileStatus } from './profile-status.model';
import { IProfileStatusService } from './iprofile-status.service';
import { ApiService } from '../../shared/api/api.service';
import { PagedResultGeneric } from 'src/app/shared';

@Injectable()
export class ProfileStatusService implements IProfileStatusService {
  private _apiService: ApiService;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  getProfileStatus = (id: number): Promise<ProfileStatus> => {
    let url: string = '/MemberType/' + id;
    return this._apiService.get(url);
  };

  getProfileStatuses(searchParams: any): Promise<PagedResultGeneric<ProfileStatus>> {
    let url: string = '/MemberTypes/';
    return this._apiService.getPaged(url, searchParams);
  }

  insertProfileStatus = (profileStatus: ProfileStatus): Promise<number> => {
    let url: string = '/MemberTypes/';
    return this._apiService.post(url, profileStatus).then((data: number): Promise<number> => {
      return Promise.resolve(data);
    });
  };

  updateProfileStatus = (profileStatus: ProfileStatus): Promise<void> => {
    let url: string = '/MemberType/' + profileStatus.ID;
    return this._apiService.put(url, profileStatus).then((): Promise<void> => {
      return Promise.resolve();
    });
  };

  updateProfileStatusAndProfiles = (profileStatus: ProfileStatus): Promise<void> => {
    let url: string = '/MemberType/' + profileStatus.ID + '/ProfileUpdate';
    return this._apiService.put(url, profileStatus).then((): Promise<void> => {
      return Promise.resolve();
    });
  };

  deleteProfileStatus = (id: number, profileStatusToMigrateTo: string): Promise<void> => {
    let url: string = '/MemberType/' + id + '?memberTypeToMigrateTo=' + encodeURIComponent(profileStatusToMigrateTo);
    return this._apiService.delete(url).then((): Promise<void> => {
      return Promise.resolve();
    });
  };
}
